module.exports = __webpack_public_path__ + "static/media/arrowup.0740ad98.svg";